import { z } from 'zod';


/* 아이디 찾기(이메일, 전화번호) 페이지 유효성 검사 zod 설정 */
export const emailSchema = z.object({
    name : z
        .string()
        .min(2, "이름은 2자 이상이어야 합니다")
        .max(10, "이름은 10자 이하이어야 합니다")
        .nonempty("이름을 입력해주세요"),
    email : z
        .string()
        .email("이메일 형식으로 입력해주세요")
        .nonempty("이메일을 입력해주세요"),
    authNumber: z
        .string()
        .length(6, '인증번호는 6자리여야 합니다.')
        .regex(/^[0-9]{6}$/, "숫자만 입력해주세요")
        .optional(),
});

export const phoneSchema = z.object({
    name : z
        .string()
        .min(2, "이름은 2자 이상이어야 합니다")
        .max(10, "이름은 10자 이하이어야 합니다")
        .nonempty("이름을 입력해주세요"),
    phoneNumber: z
        .string()
        .regex(/^010\d{8}$/, "전화번호 형식으로 입력해주세요 (예: 01012345678)")
        .nonempty("전화번호를 입력해주세요"),
    authNumber: z
        .string()
        .length(6, '인증번호는 6자리여야 합니다.')
        .regex(/^[0-9]{6}$/, "숫자만 입력해주세요")
        .optional(),
});
